import cn from "classnames";
import { FC, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getObjectsRegister, getSearchedData } from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.thunks";
import { TableBody } from "../TableBody/TableBody";
import { TableHead } from "../TableHead/TableHead";
import { ReactComponent as TableTogglerRight } from "images/TableTogglerRight.svg";
import { ReactComponent as TableTogglerLeft } from "images/TableTogglerLeft.svg";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import { NoData } from "components-new/NoData/NoData";
import styles from "./Table.module.sass";
import useDebounce from "hooks/useDebounce";

export const Table: FC = () => {
	const objectsRegisterList = useAppSelector((state) => state.objectsRegister.objectsRegisterList);

	const scrollTargetRef: any = useRef(null);
	const dispatch = useAppDispatch();
	const { lastPart, searchValue, searchMode, searchPending, searchedData, lastSearchedPart } = useAppSelector(
		(state) => state.objectsRegister,
	);
	const { organizationId } = useParams();
	const [btnToggle, setBtnToggle] = useState<boolean>(false);

	const [load, setLoad] = useState<boolean>(false);

	const query = useDebounce(searchValue, 500);
	useEffect(() => {
		if (query as string) {
			dispatch(
				getSearchedData({
					id: Number(organizationId),
					searchedPart: 1,
					quantity: 50,
					searchValue: String(query),
					setLoad: () => setLoad(false),
				}),
			);
		}
		//eslint-disable-next-line
	}, [query]);

	useEffect(() => {
		if (scrollTargetRef.current) {
			scrollTargetRef.current.addEventListener("scroll", () => checkPosition());
		}

		return () => {
			// eslint-disable-next-line react-hooks/exhaustive-deps
			if (scrollTargetRef.current) scrollTargetRef.current.removeEventListener("scroll", () => checkPosition());
		};
		//eslint-disable-next-line
	}, [scrollTargetRef.current, lastPart, lastSearchedPart]);

	useEffect(() => {
		if (!searchMode && load && organizationId && lastPart !== null) {
			dispatch(
				getObjectsRegister({ id: +organizationId, part: lastPart + 1, quantity: 50, setLoad: () => setLoad(false) }),
			);
		}
		if (searchMode && load && organizationId && lastSearchedPart !== null) {
			dispatch(
				getSearchedData({
					id: Number(organizationId),
					searchedPart: lastSearchedPart + 1,
					quantity: 50,
					searchValue: String(query),
					setLoad: () => setLoad(false),
				}),
			);
		}
		//eslint-disable-next-line
	}, [load]);

	const checkPosition = () => {
		const height = scrollTargetRef.current.scrollHeight;
		const screenHeight = scrollTargetRef.current.offsetHeight;
		const scrolled = scrollTargetRef.current.scrollTop;
		const threshold = height - screenHeight;
		const position = scrolled + screenHeight;

		if (position >= threshold && !load) setLoad(true);
	};

	const scrollHorizontally = (value: number, toggler: boolean) => {
		if (btnToggle === toggler) return;
		scrollTargetRef.current?.scrollTo({ left: value, behavior: "smooth" });
		headRef.current?.scrollTo({ left: value, behavior: "smooth" });
		setBtnToggle(toggler);
	};

	useEffect(() => {
		dispatch(getObjectsRegister({ id: Number(organizationId), part: 1, quantity: 50 }));
		//eslint-disable-next-line
	}, [organizationId, searchMode]);

	useEffect(() => {
		scrollTargetRef.current?.scrollTo({ top: 0, behavior: "instant" });
	}, [searchPending]);

	useEffect(() => {
		if (!btnToggle) scrollTargetRef.current?.scrollTo({ left: 0, behavior: "instant" });
		else scrollTargetRef.current?.scrollTo({ left: 10000, behavior: "instant" });
		//eslint-disable-next-line
	}, [searchMode, searchedData.length]);

	const headRef: any = useRef(null);

	useEffect(() => {
		if (headRef.current) {
			headRef.current.addEventListener("scroll", () => synchronizePosition());
		}

		return () => {
			if (scrollTargetRef.current) {
				// eslint-disable-next-line react-hooks/exhaustive-deps
				scrollTargetRef.current.removeEventListener("scroll", () => synchronizePosition());
			}
		};
		//eslint-disable-next-line
	}, [headRef.current]);

	const synchronizePosition = () => {
		scrollTargetRef.current.scrollLeft = headRef.current.scrollLeft;
	};

	return (
		<div className={styles["tables"]}>
			<div ref={headRef} className={styles["table-head-wrp"]}>
				<div className={styles.pointers}>
					<div
						onClick={() => scrollHorizontally(0, false)}
						className={cn(styles.pointer, btnToggle ? styles["pointer-active"] : styles["pointer-disabled"])}>
						{/* className={cn(styles.pointer, btnToggle ? styles["pointer-active"] : styles["pointer-disabled"])}> */}
						<TableTogglerLeft />
					</div>
					<div
						onClick={() => scrollHorizontally(10000, true)}
						className={cn(styles.pointer, !btnToggle ? styles["pointer-active"] : styles["pointer-disabled"])}>
						{/* className={cn(styles.pointer, styles["pointer-active"])}> */}
						<TableTogglerRight />
					</div>
				</div>
				<table className={cn(styles["table-head"], objectsRegisterList.length <= 3 && styles.noscroll)}>

					<TableHead />
				</table>
			</div>

			{searchPending ? (
				<div className="loading-wrp">
					<LoadingIcon className="loading-icon" />
				</div>
			) : (searchMode ? searchedData : objectsRegisterList).length ? (
				<div ref={scrollTargetRef} className={styles["table-body-wrp-wrp"]}>
					<div className={styles["table-body-wrp"]}>
						<table className={styles["table-body"]}>
							<TableBody />
						</table>
					</div>
				</div>
			) : (
				<NoData title="Данные отсутствуют" />
			)}
		</div>
	);
};
